import { TextField, InputAdornment, IconButton, Box } from '@mui/material'
import { useState } from 'react'
import { Controller } from 'react-hook-form'
import { Visibility, VisibilityOff } from '@mui/icons-material'
import styles from './InputCmp.module.css'

const InputCmp = ({
    label,
    onChange,
    variant,
    style,
    placeholder,
    type,
    name,
    control,
    rules,
    formatValue,
    startIcon,
    requiredAsterisk,
    prefix = '',
    ...props
}) => {
    const [showPassword, setShowPassword] = useState(false)

    const togglePasswordVisibility = () => setShowPassword((prev) => !prev)

    const renderLabel = () => {
        if (requiredAsterisk && label) {
            return (
                <span>
                    {label}
                    <span className={styles.requiredAsterisk}> *</span>
                </span>
            )
        }
        return label
    }

    return (
        <Controller
            name={name}
            rules={rules}
            control={control}
            render={({
                field: { onChange, value = '' },
                fieldState: { error },
            }) => {
                // Remove prefix from visible input (user types only the part after prefix)
                const displayValue = prefix
                    ? String(value)?.startsWith(prefix)
                        ? value?.slice(prefix.length)
                        : value
                    : value

                const handleChange = (e) => {
                    let v = e.target.value
                    // Combine prefix with user input
                    const finalValue = prefix + v
                    if (formatValue) v = formatValue(v)
                    onChange(finalValue)
                }

                return (
                    <TextField
                        label={renderLabel()}
                        variant={variant || 'outlined'}
                        placeholder={placeholder}
                        sx={{ width: '100%', ...style }}
                        InputLabelProps={{ shrink: true }}
                        type={
                            type === 'password'
                                ? showPassword
                                    ? 'text'
                                    : 'password'
                                : type
                        }
                        className={styles.inputBox + ' ' + props?.className}
                        value={displayValue}
                        onChange={handleChange}
                        error={!!error}
                        helperText={error ? error.message : null}
                        InputProps={{
                            startAdornment: (
                                <>
                                    {startIcon ? (
                                        <InputAdornment position="start">
                                            {startIcon}
                                        </InputAdornment>
                                    ) : null}

                                    {prefix && (
                                        <Box
                                            sx={{
                                                color: '#6b7280',
                                                // fontSize: '0.95rem',
                                                fontFamily: 'inherit',
                                                userSelect: 'none',
                                                pointerEvents: 'none',
                                                mr: 0.3,
                                                textWrap: 'nowrap',
                                            }}
                                        >
                                            {prefix}
                                        </Box>
                                    )}
                                </>
                            ),
                            endAdornment:
                                type === 'password' ? (
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={togglePasswordVisibility}
                                            edge="end"
                                        >
                                            {showPassword ? (
                                                <VisibilityOff />
                                            ) : (
                                                <Visibility />
                                            )}
                                        </IconButton>
                                    </InputAdornment>
                                ) : null,
                        }}
                        {...props}
                    />
                )
            }}
        />
    )
}

export default InputCmp
